<!--
    描述：项目列表 新增/编辑 弹窗
    时间：2020-03-23
    Created by ws
-->
<template>
	<div class="">
		<el-form :model="projectForm"
				 :rules="projectRules"
				 ref="projectForm"
				 label-width="90px">
			<el-form-item label="项目名称"
						  prop="pname"
						  :show-message="false">
				<el-input v-model="projectForm.pname"
						  :disabled="isDisabled"
						  autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="启动日期"
						  prop="startDate"
						  :show-message="false">
				<el-date-picker v-model="projectForm.startDate"
								type="date"
								:disabled="isDisabled"
								placeholder="选择日期">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="委托单位"
						  prop="client">
				<el-input v-model="projectForm.client"
						  autocomplete="off"
						  :disabled="isDisabled"
						  :show-message="false"></el-input>
			</el-form-item>
			<el-form-item label="使用单位"
						  prop="userCompany">
				<el-input v-model="projectForm.userCompany"
						  :disabled="isDisabled"
						  autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="项目类型"
						  prop="ptype">
				<el-input v-model="projectForm.ptype"
						  :disabled="isDisabled"
						  autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="数据库名称"
						  prop="dbName"
						  :show-message="false">
				<el-input v-model="projectForm.dbName"
						  :disabled="isDisabled"
						  autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="数据库类型"
						  prop="dbType">
				<el-input v-model="projectForm.dbType"
						  :disabled="isDisabled"
						  autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="数据库版本"
						  prop="dbVersion">
				<el-input v-model="projectForm.dbVersion"
						  :disabled="isDisabled"
						  autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="项目负责人"
						  prop="mname">
				<el-input v-model="projectForm.mname"
						  :disabled="isDisabled"
						  autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="产品经理"
						  prop="pmName">
				<el-input v-model="projectForm.pmName"
						  :disabled="isDisabled"
						  autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="开发经理"
						  prop="dmName">
				<el-input v-model="projectForm.dmName"
						  :disabled="isDisabled"
						  autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="测试经理"
						  prop="tmName">
				<el-input v-model="projectForm.tmName"
						  :disabled="isDisabled"
						  autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="项目状态"
						  prop="pstatus">
				<el-select v-model="projectForm.pstatus"
						   :disabled="isDisabled"
						   placeholder="请选择项目状态">
					<el-option label="开发" value="20001"></el-option>
					<el-option label="测试" value="20002"></el-option>
					<el-option label="生产" value="20003"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="备注"
						  prop="remark">
				<el-input type="textarea"
						  :rows="2"
						  :disabled="isDisabled"
						  placeholder="请输入内容"
						  v-model="projectForm.remark">
				</el-input>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import {
	getInfo,
	saveProject,
	updateProject
} from '@/api/modules/dataProject.js'
export default {
	props: {
		// 当前查看类型
		mode: {
			type: String,
			default: 'add'
		},
		// 当前的 项目ID
		projectId: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			projectForm: {
				pname: '',
				startDate: '',
				client: ''
			},
			projectRules: {
				pname: [{ required: true }],
				startDate: [{ required: true, type: 'date', trigger: 'change' }]
			},
			operateData: {}
		}
	},
	methods: {
		// 查看、编辑 回显数据
		initProject() {
			this.operateData.id = this.projectId;
			getInfo(this.operateData).then(res => {
				// console.log(res)
				let params = res.data
				params.startDate = new Date(res.data.startDate)
				this.projectForm = params
			})
		},
		// 保存项目
		doSave() {
			let params = Object.assign({}, this.projectForm)

			this.$refs.projectForm.validate(valid => {
				if (valid) {
                    // 新增
					if (this.mode === 'add') {
						saveProject(params).then(res => {
							// console.log(res)
							this.$emit('onSuccess')
						})
					} else {
                        // 编辑
						updateProject(params).then(res => {
							this.$emit('onSuccess')
						}).catch(err => {
                            this.$emit('onWait')
                        })
					}
				} else {
					this.$emit('onWait')
					this.$message.error('请完善必填项信息！')
				}
			})
		}
	},
	created() {
		if (this.mode !== 'add') {
			// 初始渲染数据
			this.initProject()
		}
	},
	computed: {
		// 是否可编辑
		isDisabled() {
			return this.mode === 'view' ? true : false
		}
	}
}
</script>

<style scoped lang="less">
</style>
